module.exports = __webpack_public_path__ + "img/meta-bg.92e38c44.jpg";